export enum LoggerLevel {
  print = -1,
  debug = 0,
  info = 1,
  warn = 2,
  error = 3,
  fatal = 4,
  none = 5,
}

export type LoggerLevelKey = keyof typeof LoggerLevel;

export const metrics_category = 'metrics_category';

export type GetAvgDelta = () => number;
